import { Box } from '@mui/material';
import { FunctionComponent } from 'react';

interface Props {
  title: string;
}

export const ViewHeader: FunctionComponent<Props> = ({ title }) => {
  return <Box sx={{ fontSize: 24, fontWeight: 700, pb: 4 }}>{title}</Box>;
};
